// sequences.js
export const TALK_LOOP = [
  //{ mouth: "talk1", eyes: "open",  extra: "none",  duration: 120 },
 // { mouth: "talk2", eyes: "open",  extra: "none",  duration: 120 },
 // { mouth: "talk3", eyes: "open",  extra: "none",  duration: 120 },
 // { mouth: "talk2", eyes: "open",  extra: "none",  duration: 120 },
  { mouth: "smile", eyes: "open",  extra: "none", eyebrows:"straight", duration: 320 },
  { mouth: "oval", eyes: "open",  extra: "none",  eyebrows:"straight",  duration: 320 },
  { mouth: "smile", eyes: "closed", extra: "none", duration: 120 },
  { mouth: "smile", eyes: "open",  extra: "none", eyebrows:"straight", duration: 320 },
  { mouth: "oval", eyes: "open",  extra: "none",  eyebrows:"straight",  duration: 320 },
   { mouth: "smile", eyes: "closed", extra: "none", duration: 150 },
  { mouth: "smile", eyes: "open",  extra: "none", eyebrows:"straight", duration: 320 },
  { mouth: "oval", eyes: "open",  extra: "none",  eyebrows:"straight",  duration: 320 },

];

export const SLEEP_LOOP = [
  { mouth: "smile", eyes: "closed", extra: "sleep1", duration: 1200 },
    { mouth: "smile", eyes: "closed", extra: "sleep2", duration: 1200 },
      { mouth: "smile", eyes: "closed", extra: "sleep3", duration: 1200 },
        { mouth: "smile", eyes: "closed", extra: "none", duration: 600 },



]; // just holds the pose, but loops to keep it “animated”

// Neutral with a periodic blink
export const NEUTRAL_BLINK = [
  { mouth: "smile", eyes: "open",   extra: "none",  eyebrows:"straight" , duration: 120 },
  { mouth: "smile", eyes: "closed", extra: "none", eyebrows:"straight_up" ,  duration: 220 },
  { mouth: "smile", eyes: "open",   extra: "none", eyebrows:"straight_up" ,  duration: 5200 },
];

export const MUSIC = [
  { mouth:"none", eyes:"happy", extra:"music", duration: 800  },
  { mouth:"none", eyes:"happy", extra:"music2", duration: 800  }
];